import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles, Activity, Gauge, AlertTriangle, MoonStar } from "lucide-react";

/**
 * Small pill showing the member's current engagement tier. Used inside the
 * Admin member-edit modal header and in member list rows. Computed lazily
 * by hitting /api/members/{id}/engagement. Renders nothing while loading
 * (avoids layout shift in the modal header).
 */
const TIER_STYLE = {
  highly_active: { label: "Highly Active", cls: "bg-[#1F7A3D] text-white", icon: Sparkles },
  active:        { label: "Active",        cls: "bg-[#1E4F87] text-white", icon: Activity },
  moderate:      { label: "Moderate",      cls: "bg-[#C89B3C] text-[#1F1300]", icon: Gauge },
  at_risk:       { label: "At Risk",       cls: "bg-[#A53A2A] text-white", icon: AlertTriangle },
  inactive:      { label: "Inactive",      cls: "bg-[#5C6B7A] text-white", icon: MoonStar },
};

export function EngagementBadge({ memberId, size = "md" }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (!memberId) return;
    let alive = true;
    api.get(`/members/${memberId}/engagement`)
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => { if (alive) setErr(true); });
    return () => { alive = false; };
  }, [memberId]);

  if (err || !data) return null;
  const cfg = TIER_STYLE[data.tier] || TIER_STYLE.inactive;
  const Icon = cfg.icon;
  const sizing = size === "sm"
    ? "px-2 py-0.5 text-[10px] gap-1"
    : "px-2.5 py-1 text-xs gap-1.5";
  return (
    <span
      title={`Engagement score · ${data.score}/100`}
      data-testid={`engagement-badge-${memberId}`}
      data-engagement-tier={data.tier}
      className={`inline-flex items-center rounded-full font-semibold ${cfg.cls} ${sizing}`}
    >
      <Icon className={size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3"} />
      {cfg.label}
    </span>
  );
}
